import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.substring(1) : hash);
    const sid = params.get("session_id");

    (async () => {
      if (!sid) { navigate("/login", { replace: true }); return; }
      try {
        const invitation_code = sessionStorage.getItem("caring:invitation_code") || undefined;
        const { data } = await api.post("/auth/google/session", { session_id: sid, invitation_code });
        sessionStorage.removeItem("caring:invitation_code");
        setUser(data);
        // Clean fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        const returnTo = sessionStorage.getItem("caring:return_to");
        sessionStorage.removeItem("caring:return_to");
        navigate(returnTo || (data.role === "admin" ? "/admin" : "/dashboard"), { replace: true });
      } catch (err) {
        toast.error(formatApiError(err.response?.data?.detail) || "Falha na autenticação Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bone)]">
      <div className="text-center">
        <div className="animate-pulse font-heading text-2xl text-[var(--forest)]">A autenticar…</div>
        <p className="text-sm text-[var(--ink-soft)] mt-2">Estamos a preparar a sua conta CARING.</p>
      </div>
    </div>
  );
}
